'use client';

import React, { useState, useEffect } from 'react';
import { useTranslations } from 'next-intl';

export function InteractiveShareButton() {
  const t = useTranslations('InteractiveShareButton');
  const [copied, setCopied] = useState(false);
  const [showCopiedMessage, setShowCopiedMessage] = useState(false);

  // Effect to hide the message after a delay
  useEffect(() => {
    if (copied) {
      setShowCopiedMessage(true);
      const timer = setTimeout(() => {
        setShowCopiedMessage(false);
        setCopied(false); // Reset copied state
      }, 2000);
      return () => clearTimeout(timer); // Cleanup timer on unmount or re-trigger
    }
  }, [copied]);

  const handleShareClick = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(window.location.href)
        .then(() => {
          setCopied(true);
        })
        .catch(err => {
          console.error('Failed to copy URL: ', err);
        });
    } else {
      console.warn('Clipboard API not available.');
    }
  };

  return (
    <div className="share-container" onClick={handleShareClick} style={{ cursor: 'pointer' }}>
      {t('share')}
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Share">
          <path
            id="Shape"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.25 4.5C16.0074 4.5 15 5.50736 15 6.75C15 7.99264 16.0074 9 17.25 9C18.4926 9 19.5 7.99264 19.5 6.75C19.5 5.50736 18.4926 4.5 17.25 4.5ZM13.5 6.75C13.5 4.67893 15.1789 3 17.25 3C19.3211 3 21 4.67893 21 6.75C21 8.82107 19.3211 10.5 17.25 10.5C15.8447 10.5 14.6199 9.72696 13.9777 8.58292L10.3631 10.9926C10.4523 11.3132 10.5 11.651 10.5 12C10.5 12.349 10.4523 12.6868 10.3631 13.0074L13.9777 15.4171C14.6199 14.2731 15.8447 13.5 17.25 13.5C19.3211 13.5 21 15.1789 21 17.25C21 19.3211 19.3211 21 17.25 21C15.1789 21 13.5 19.3211 13.5 17.25C13.5 17.1359 13.5051 17.023 13.5151 16.9115L9.67263 14.3498C8.98527 15.2037 7.93144 15.75 6.75 15.75C4.67893 15.75 3 14.0711 3 12C3 9.92893 4.67893 8.25 6.75 8.25C7.93144 8.25 8.98528 8.79635 9.67264 9.65018L13.5151 7.08856C13.5051 6.97704 13.5 6.86412 13.5 6.75ZM6.75 9.75C5.50736 9.75 4.5 10.7574 4.5 12C4.5 13.2426 5.50736 14.25 6.75 14.25C7.99264 14.25 9 13.2426 9 12C9 10.7574 7.99264 9.75 6.75 9.75ZM15 17.25C15 16.0074 16.0074 15 17.25 15C18.4926 15 19.5 16.0074 19.5 17.25C19.5 18.4926 18.4926 19.5 17.25 19.5C16.0074 19.5 15 18.4926 15 17.25Z"
            fill="#1351EC"
          />
        </g>
      </svg>
      {showCopiedMessage && (
        <div className="copied show">{t('copied')}</div>
      )}
    </div>
  );
}